import React, { Suspense } from 'react'
import styled from "styled-components";
import sainteArche from '../../assets/img/sainte-arche.jpg';

const SainteArche = styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    background-image: url(${sainteArche});
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover;
    height: 45em;
    border-radius: 4em;
    margin: 2em 10%;
    @media (max-width: 768px) {
        display: none;
    }
`;

export default SainteArche;


// WEBPACK FOOTER //
// ./src/pages/SainteArche/SainteArche.jsx